import "@styles/globals.css";
import "@utils/Config";
import { Root } from "@components/Root";
import AppCanvas from "@components/AppCanvas";
import { AnimationConfig } from "react-spring";
import { EScenario } from "@utils/Scenarios";
import { Main } from "@components/Main";
import { Scene } from "@components/Scene";
import { Loader } from "@components/Loader";
import { Interaction } from "@components/Interaction";

export type Spring = Partial<AnimationConfig>;
export type AppData = {
    scenario: EScenario;
    prevScenario: EScenario;
    passedTime: number;
};

function App() {
    return (
        <Root singlePage dynamic={[1920, 1080, 720, 1440]} mobile={1.2}>
            {({ mobile, pageWidth, pageHeight, ref, scale }) => (<>
                <Loader>
                    <Interaction>
                        <Main mobile={mobile} scale={scale} />
                        <AppCanvas Component={Scene} eventSource={ref} width={pageWidth} height={pageHeight} mobile={mobile} scale={scale} />
                    </Interaction>
                </Loader>
            </>)}
        </Root>
    );
}

export default App;
